import configService from "@app/config/ConfigService";

// craco injects VERSION as `<package.json version> @ <build date> @ <tz>`.
const getWebAppVersion = (): string => configService.getVersion().split(/\s*@\s*/)[0];

export default getWebAppVersion;
